module.exports = __webpack_public_path__ + "img/vis23InkSight.ecd6adbe.png";